import { makeRequest } from 'utils/requestLogger';

// Subjects
const showAllSubjects = () => makeRequest('get', '/api/subjects');
const showSubjects = () => makeRequest('get', '/api/subjects/universe');
const showSubjectsForSchool = () => makeRequest('get', '/api/schools/subjects');
const createNewSubject = (subject_name) =>
  makeRequest('post', '/api/subjects', { subject_name });
const editSubject = (subject_id, payload) =>
  makeRequest('put', `/api/subjects/${subject_id}`, payload);
const deleteSubject = (subject_id) =>
  makeRequest('delete', `/api/subjects/${subject_id}`);
const getSubjectWithCategoriesPositions = (subject_id) =>
  makeRequest('get', `/api/subjects/${subject_id}/categories`);

// Grades
const showAllGrades = () => makeRequest('get', '/api/grades');
const createNewGrade = (grade_level) =>
  makeRequest('post', '/api/grades', { grade_level });
const editGradeLevel = (current_grade_level, new_grade_level) =>
  makeRequest('put', `/api/grades/${current_grade_level}`, new_grade_level);
const deleteGradeLevel = (grade_level) =>
  makeRequest('delete', `/api/grades/${grade_level}`);


// Skills
const showAllSkills = () => makeRequest('get', '/api/skills');

const createNewSkill = (skill) =>
  makeRequest('post', '/api/skills', { name: skill });

const editSkill = (current_skill_id, new_skill) =>
  makeRequest('put', `/api/skills/${current_skill_id}`, new_skill);

const deleteSkill = (skill_id) =>
  makeRequest('delete', `/api/skills/${skill_id}`);

// Universe Categories
const showAllUniverseCategories = () =>
  makeRequest('get', '/api/universe_categories');
const createUniverseCategory = (category_name) =>
  makeRequest('post', '/api/universe_categories', { category_name });
const showUniverseCategory = (category_id) =>
  makeRequest('get', `/api/universe_categories/${category_id}`);
const editUniverseCategory = (category_id, payload) =>
  makeRequest('put', `/api/universe_categories/${category_id}`, payload);
const deleteUniverseCategory = (category_id) =>
  makeRequest('delete', `/api/universe_categories/${category_id}`);

// Schools
const getAllSchools = (query) =>
  makeRequest('get', `/api/schools${query ? '?q=' + query : ''}`);
const getSchool = (school_id) =>
  makeRequest('get', `/api/schools/${school_id}`);
const editSchool = (school_id, edit_payload) =>
  makeRequest('put', `/api/schools/${school_id}`, edit_payload);
const createSchool = () => makeRequest('post', '/api/schools/');
const deleteSchool = (school_id) => makeRequest('delete', `/api/schools/${school_id}`);
const getSchoolOnlineRoundtableSummary = (school_id, email_query) =>
  makeRequest(
    'get',
    `/api/schools/${school_id}/get-online-roundtable-summary${email_query ? '?email_query=' + email_query : ''
    }`
  );
const getSchoolLiveDiscussionSummary = (school_id, email_query) =>
  makeRequest(
    'get',
    `/api/schools/${school_id}/get-live-discussion-summary${email_query ? '?email_query=' + email_query : ''
    }`
  );
const getNumberStudentsEnrolled = (school_id, email_query) =>
  makeRequest(
    'get',
    `/api/schools/${school_id}/get-number-students-enrolled${email_query ? '?email_query=' + email_query : ''
    }`
  );
const getActiveTeachersAndStudents = (school_id, email_query, payload) =>
  makeRequest(
    'post',
    `/api/schools/${school_id}/get-active-teachers-students${email_query ? '?email_query=' + email_query : ''
    }`,
    payload
  );
const getSitesOfSchool = (school_id) =>
  makeRequest('get', `/api/schools_sites/${school_id}`);

// Districts
const getAllDistricts = () => makeRequest('get', '/api/districts');
const getDistrict = (districtID) =>
  makeRequest('get', `/api/districts/${districtID}`);
const createDistrictMembership = (districtID, payload) =>
  makeRequest(
    'post',
    `/api/districts/${districtID}/district_membership`,
    payload
  );

// School Users
const getUsersOfSchool = (school_id, filters) =>
  makeRequest('post', `/api/schools/${school_id}/users`, filters);

const getFilteredUsersOfSchool = (school_id, filters) =>
  makeRequest('post', `/api/schools/${school_id}/filtered-users`, filters);

const getTeachersOfSchool = (school_id) =>
  makeRequest('get', `/api/schools/${school_id}/teachers`);

const getTeacherOfCourse = (school_id, course_id) =>
  makeRequest('get', `/api/schools/${school_id}/courses/${course_id}/teachers`);

//School Courses
const addCoursesJob = (school_id, payload) =>
  makeRequest('post', `api/schools/${school_id}/courses/job`, payload);

const getUsersEmailsOfSchool = (school_id) =>
  makeRequest('get', `api/schools/${school_id}/users-emails`);

const getCoursesJobResponse = (school_id, job_id) =>
  makeRequest('get', `api/schools/${school_id}/courses/job/${job_id}`);

const getSchoolCourses = (school_id, payload) =>
  makeRequest('post', `/api/schools/${school_id}/courses`, payload);

const updateCourseTeacherCoTeachers = (course_id, teachers_id) =>
  makeRequest('put', `/api/courses/${course_id}/teachers`, teachers_id);

const stayWithTeacher = (course_id) =>
  makeRequest('put', `/api/courses/${course_id}/stay-with-teacher`);

const getCoursesByTeacher = (id, teacherIDs) =>
  makeRequest('post', `/api/schools/${id}/teacher-courses/`, teacherIDs).then(
    (res) => res.data
  );

const deleteSchoolCourses = (school_id, coursesId) =>
  makeRequest('put', `/api/schools/${school_id}/delete-courses`, coursesId);

const archiveSchoolCourses = (school_id, coursesId) =>
  makeRequest('put', `/api/schools/${school_id}/toggle_archived_courses_status`, coursesId);

//Add users to school
const addUsersJob = (school_id, payload) =>
  makeRequest('post', `api/schools/${school_id}/users/job`, payload);

const getUsersJobResponse = (school_id, job_id) =>
  makeRequest('get', `api/schools/${school_id}/users/job/${job_id}`);

const getUserDetailsOfSchool = (school_id, user_id) =>
  makeRequest('get', `/api/schools/${school_id}/users/${user_id}`);

const getUserDetails = (user_id) =>
  makeRequest('get', `/api/users/${user_id}/user-details`);

const getAdminUsersOfSchool = (code) =>
  makeRequest('get', `/api/schools/${code}/admins`);

const removeUsersOfSchool = (school_id, usersId) => {
  return makeRequest('put', `/api/schools/${school_id}/delete-users`, usersId);
};

const updateSchoolUserAdminRole = (school_id, user_id, payload) => {
  return makeRequest(
    'put',
    `/api/schools/${school_id}/update-admin-role/${user_id}`,
    payload
  );
};

const getTrialTeachers = (school_id, payload) => {
  return makeRequest(
    'post',
    `/api/schools/${school_id}/trial-teachers`, payload
  );
};

const upgradeTrialUser = (school_id, user_id, payload) => {
  return makeRequest(
    'put',
    `/api/schools/${school_id}/upgrade-user/${user_id}`,
    payload
  );
};

const updateUserRole = (school_id, userId, payload) =>
  makeRequest(
    'put',
    `api/schools/${school_id}/update-user-role/${userId}`,
    payload
  );

const updateUserSchoolSite = (school_id, userId, payload) =>
  makeRequest(
    'put',
    `api/schools/${school_id}/update-user-school_site/${userId}`,
    payload
  );

const updateUserSchoolRole = (school_id, userId, payload) =>
  makeRequest(
    'put',
    `api/schools/${school_id}/update-user-school-role/${userId}`,
    payload
  );

const getSchoolUserCourses = (school_id, user_id) =>
  makeRequest('get', `/api/schools/${school_id}/user-courses/${user_id}`);

// Users
// expects query object with 'email_query', 'role' -optional
const getUsersByEmail = (email_query, role) =>
  makeRequest(
    'get',
    `/api/users/get-users-by-email?email_query=${email_query || ''}&role=${role || ''
    }`
  );

const getCoteacherByEmail = (payload) =>
  makeRequest(
    'post',
    `/api/users/get-coteacher-by-email`, payload);

const getUser = (id) => makeRequest('get', `/api/users/${id}`);
const adminUpdateUser = (id, payload) =>
  makeRequest('put', `api/users/${id}/admin-update-user`, payload);


//Users for Parlay Team
const getFilteredUsersInParlay = (filters) =>
  makeRequest(
    'post',
    `/api/users/admin-portal`, filters);

const deleteUser = (user_ids) =>
  makeRequest(
    'post',
    `/api/users/delete-users`, user_ids
  );

const getUserCourses = (user_id) =>
  makeRequest('get', `/api/users/${user_id}/user-courses`);

// User memberships
const upgradeTeacher = (user_id, payload) =>
  makeRequest('post', `/api/users/${user_id}/membership`, payload);

// School Invite codes
const createSchoolCode = (school_id, code) =>
  makeRequest('post', '/api/invites/', { school_id, code });
const editSchoolInvite = (invite_id, payload) =>
  makeRequest('put', `/api/invites/${invite_id}`, payload);

// School Memberships
const getSchoolMemberships = (school_id) =>
  makeRequest('get', `/api/schools_memberships/schools/${school_id}`);
const getSchoolMembershipTypes = () =>
  makeRequest('get', `/api/schools_memberships/types`);
const createSchoolMembership = (payload) =>
  makeRequest('post', '/api/schools_memberships/', payload);
const deleteSchoolMembership = (school_membership_id) =>
  makeRequest('delete', `/api/schools_memberships/${school_membership_id}`);

// Activity passes
const createActivityPasses = (user_id, passes_to_create) =>
  makeRequest('post', `/api/users/${user_id}/activity_passes/`, {
    passes_to_create,
  });

// Admin Portal Suggestions
const createSuggestion = (school_id, payload) =>
  makeRequest('post', `/api/schools/${school_id}/suggestions`, payload);

const editSuggestion = (school_id, suggestion_id, payload) =>
  makeRequest('put', `/api/schools/${school_id}/suggestions/${suggestion_id}`, payload);

const getSuggestions = (school_id) =>
  makeRequest('get', `/api/schools/${school_id}/suggestions`);


const deleteSuggestion = (school_id, suggestion_id) =>
  makeRequest(
    'delete',
    `/api/schools/${school_id}/suggestions/${suggestion_id}`
  );

const getTeachersWithLicense = (school_id, payload) =>
  makeRequest('post', `api/schools/${school_id}/teachers-licenses`, payload);


const getSchoolCoachesAndAdmins = (school_id) =>
  makeRequest('get', `api/schools/${school_id}/coaches_and_admins`);
// Tags
const getTagsByTerm = (term) => makeRequest('get', `/api/tags?filter=${term}`);

// Skills
const getSkillsByTerm = (term) => makeRequest('get', `/api/skills?filter=${term}`);

//Admin Portal Analytics
const getActiveTeachers = (school_id, payload) =>
  makeRequest('get', `/api/schools/${school_id}/analytics/active-teachers?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getActiveStudents = (school_id, payload) =>
  makeRequest('get', `/api/schools/${school_id}/analytics/active-students?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getRoundtableDiscussions = (school_id, payload) =>
  makeRequest('get', `/api/schools/${school_id}/analytics/roundtable-discussions?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getRoundtableDiscussionsRun = (school_id, payload) =>
  makeRequest('get', `/api/schools/${school_id}/analytics/roundtable-discussions-run?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getDiscussionsCreated = (school_id, payload) =>
  makeRequest('get', `/api/schools/${school_id}/analytics/discussions-created?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getRoundtablesCreated = (school_id, payload) =>
  makeRequest('get', `/api/schools/${school_id}/analytics/roundtables-created?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getDiscussionsRun = (school_id, payload) =>
  makeRequest('get', `/api/schools/${school_id}/analytics/discussions-run?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getRoundtablesRun = (school_id, payload) =>
  makeRequest('get', `/api/schools/${school_id}/analytics/roundtables-run?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getUniverseTopicsUsed = (school_id, payload) =>
  makeRequest('get', `/api/schools/${school_id}/analytics/universe-topics-used?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getSchoolAnalyticsMostActiveTeachers = (school_id, dates) =>
  makeRequest('get', `api/schools/${school_id}/analytics/most-active-teachers?begin_date=${dates.begin_date}&end_date=${dates.end_date}`);

const getSchoolAnalyticsInactiveTeachers = (school_id, dates) =>
  makeRequest('get', `api/schools/${school_id}/analytics/inactive-teachers?begin_date=${dates.begin_date}&end_date=${dates.end_date}`);

const getSchoolAnalyticsRecentTopicsUsed = (school_id, dates) =>
  makeRequest('get', `api/schools/${school_id}/analytics/recent-topics-used?begin_date=${dates.begin_date}&end_date=${dates.end_date}`);

const getSchoolAnalyticsTopUniversePortfolios = (school_id) =>
  makeRequest('get', `api/schools/${school_id}/analytics/top-universe-portfolios`);

const getSchoolAnalyticsNumberOfRts = (school_id, dates) =>
  makeRequest('get', `api/schools/${school_id}/analytics/number-of-roundtables?begin_date=${dates.begin_date}&end_date=${dates.end_date}`);

const getSchoolAnalyticsTimeSpentOnParlay = (school_id, dates) =>
  makeRequest('get', `api/schools/${school_id}/analytics/time-spent-on-parlay?begin_date=${dates.begin_date}&end_date=${dates.end_date}`);

const getSchoolAnalyticsOnlineRts = (school_id, dates) =>
  makeRequest('get', `api/schools/${school_id}/analytics/roundtables?type=online&begin_date=${dates.begin_date}&end_date=${dates.end_date}`);

const getSchoolAnalyticsLiveRts = (school_id, dates) =>
  makeRequest('get', `api/schools/${school_id}/analytics/roundtables?type=live&begin_date=${dates.begin_date}&end_date=${dates.end_date}`);

const getOnlineRoundtableEngagement = (school_id, payload) =>
  makeRequest('get', `api/schools/${school_id}/analytics/online-roundtables-engagement?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getLiveRoundtableEngagement = (school_id, payload) =>
  makeRequest('get', `api/schools/${school_id}/analytics/live-roundtables-engagement?begin_date=${payload.begin_date}&end_date=${payload.end_date}`);

const getTotalSchoolUsersCount = (school_id) =>
  makeRequest('get', `api/schools/${school_id}/users/count`);

const getTotalSchoolCoursesCount = (school_id) =>
  makeRequest('get', `api/schools/${school_id}/courses/count`);

//Admin Portal Analytics - System Wide Data
const getSystemWideData = (payload, type) =>
  makeRequest('get', `/api/users/analytics?begin_date=${payload.begin_date}&end_date=${payload.end_date}&email_domain=${payload.email_domain}&type=${type}`);

const getRoundtablesAnalytics = (payload, type) =>
  makeRequest('get', `/api/users/analytics/roundtables?begin_date=${payload.begin_date}&end_date=${payload.end_date}&email_domain=${payload.email_domain}&type=${type}&page_number=${payload.page_number}&page_size=${payload.page_size}`);

const getLatestDateUpdate = () =>
  makeRequest('get', `/api/jobs/latest`);

const createPremadePoll = ({ premade_id, question, answers, status }) =>
  makeRequest('post', `/api/premades/polls`, {
    premade_id,
    question,
    answers,
    status,
  });

const editPremadePoll = (poll_id, payload) =>
  makeRequest('put', `/api/premades/poll/${poll_id}`, payload);

const deletePremadePoll = (poll_id) =>
  makeRequest('delete', `/api/premades/poll/${poll_id}/delete`);
// Admin Portal Integrations
const getEdlinkMetadata = (school_id) =>
  makeRequest('get', `/api/integrations/edlink?school_id=${school_id}`);

const getSsoCourseMetadata = (course_id, redirect_uri, integration_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/courses/${course_id}/metadata?redirect_uri=${redirect_uri}&integration_id=${integration_id}`);

const getSsoIntegrationProfile = (integration_id) =>
  makeRequest('get', `api/integrations/edlink/sso/integrations/${integration_id}/profile`);

const setSsoIntegrationProfile = (integration_id) =>
  makeRequest('put', `api/integrations/edlink/sso/integrations/${integration_id}/profile`);

const getSsoMetadata = (redirect_uri, integration_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/metadata?redirect_uri=${redirect_uri}&integration_id=${integration_id}`);

const getAccessToken = (code, redirect_uri) =>
  makeRequest('get', `/api/integrations/edlink/access-token?code=${code}&redirect_uri=${redirect_uri}`);

const refreshAccessToken = () =>
  makeRequest('get', `/api/integrations/edlink/refresh-access-token`);

const getEdlinkIntegrations = () =>
  makeRequest('get', `/api/integrations/edlink/integrations`);

const getEdlinkIntegrationsSchool = (school_id) =>
  makeRequest('post', `/api/integrations/edlink/integrations/schools/${school_id}`);

const generateSsoTokens = (payload) =>
  makeRequest('post', `/api/integrations/edlink/sso/access-token`, payload);

const generateSubscriptionSsoTokens = (payload) =>
  makeRequest('post', `/api/integrations/edlink/sso/courses/${payload.course_id}/subscription/access-token`, payload);

const getSsoProviders = () =>
  makeRequest('get', `/api/integrations/edlink/sso/providers`);

const getSsoCourseProviders = (course_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/courses/${course_id}/providers`);

const getSsoIntegration = (course_id, integration_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/courses/${course_id}/integrations/${integration_id}`);

const getSsoCourses = (course_id, integration_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/courses/${course_id}/integrations/${integration_id}/courses`);

const getSsoCourseStudents = (integration_id, course_id, edlink_course_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/courses/${course_id}/integrations/${integration_id}/courses/${edlink_course_id}/students`);

const getSsoCourseTeachers = (integration_id, course_id, edlink_course_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/courses/${course_id}/integrations/${integration_id}/courses/${edlink_course_id}/teachers`);

const getCourseCategories = (integration_id, course_id, edlink_course_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/courses/${course_id}/integrations/${integration_id}/courses/${edlink_course_id}/categories`);

const importSsoCourseStudents = (integration_id, course_id, edlink_course_id, students, edlink_course_name) =>
  makeRequest('post', `/api/integrations/edlink/sso/courses/${course_id}/integrations/${integration_id}/courses/${edlink_course_id}/students`, { students, edlink_course_name });

const disconnectSsoIntegration = (integration_id) =>
  makeRequest('put', `/api/integrations/edlink/sso/integrations/${integration_id}`);

const disconnectSsoCourseIntegration = (course_id, integration_id, remove_students) =>
  makeRequest('put', `/api/integrations/edlink/sso/courses/${course_id}/integrations/${integration_id}`, remove_students);

const disconnectStudentSsoIntegration = (course_id, integration_id) =>
  makeRequest('put', `/api/integrations/edlink/sso/courses/${course_id}/integrations/${integration_id}/disconnect-student`);


const getEdlinkProviders = () =>
  makeRequest('get', `/api/integrations/edlink/providers`);

const associateEdlinkIntegrationWithSchool = (payload) =>
  makeRequest('post', `/api/integrations/edlink/integrations`, payload);

const getEdlinkSchoolProviders = (school_id) =>
  makeRequest('get', `/api/integrations/edlink/providers?school_id=${school_id}`);

const getEdlinkSchoolIntegrationCourses = (school_id, integration_id, filters) =>
  makeRequest('get', `/api/integrations/edlink/schools/${school_id}/integrations/${integration_id}/courses?title=${filters.course_title}&teacher_email=${filters.teacher_email}&is_connected=${filters.is_connected}&school_site=${filters.school_site}&page=${filters.page}&subject=${filters.subject}&grade=${filters.grade}`);

const getEdlinkSchoolIntegrationCoursesFilters = (school_id, integration_id) =>
  makeRequest('get', `/api/integrations/edlink/schools/${school_id}/integrations/${integration_id}/courses-filters`);

const rosterSchoolDataJob = (school_id, integration_id, payload) =>
  makeRequest('post', `/api/integrations/edlink/schools/${school_id}/integrations/${integration_id}/roster/job`, payload);

const getRosterSchoolDataJobStatus = (school_id, integration_id, job_id) =>
  makeRequest('get', `/api/integrations/edlink/schools/${school_id}/integrations/${integration_id}/roster/job/${job_id}`);

const getUserSchoolIntegrations = () =>
  makeRequest('get', `/api/integrations/edlink/sso/schools-integrations`);

const getEdlinkSchoolIntegrationTeachers = (school_id, integration_id, payload) =>
  makeRequest('post', `/api/integrations/edlink/schools/${school_id}/integrations/${integration_id}/teachers`, payload);

const rosterEdlinkSchoolIntegrationTeachersJob = (school_id, integration_id, payload) =>
  makeRequest('post', `/api/integrations/edlink/schools/${school_id}/integrations/${integration_id}/teachers/job`, payload);

const getRosterEdlinkSchoolIntegrationTeachersJobStatus = (school_id, integration_id, job_id) =>
  makeRequest('get', `/api/integrations/edlink/schools/${school_id}/integrations/${integration_id}/teachers/job/${job_id}`);

const populateEdlinkSchoolIntegrationCoursesJob = (school_id, integration_id) =>
  makeRequest('post', `/api/integrations/edlink/schools/${school_id}/integrations/${integration_id}/courses/job`);

const getPopulateEdlinkSchoolIntegrationCoursesJobStatus = (school_id, integration_id, job_id) =>
  makeRequest('get', `/api/integrations/edlink/schools/${school_id}/integrations/${integration_id}/courses/job/${job_id}`);

const unsyncProviderStudentFromCourse = (course_id, integration_id, edlink_course_id, payload) =>
  makeRequest('put', `/api/integrations/edlink/sso/courses/${course_id}/integrations/${integration_id}/courses/${edlink_course_id}/students/unsync-student-course`, payload);

const getAvailableAssignmentsStudents = (id, integration_id, edlink_course_id) =>
  makeRequest('get', `api/integrations/edlink/sso/courses/${id}/integrations/${integration_id}/courses/${edlink_course_id}/assignments/students`);

const createSsoCourseAssignment = (id, integration_id, edlink_course_id, activity_type, activity_id, payload) =>
  makeRequest('post', `api/integrations/edlink/sso/courses/${id}/integrations/${integration_id}/courses/${edlink_course_id}/activities/${activity_type}/${activity_id}/assignments`, payload);

const updateSsoCourseAssignment = (id, integration_id, edlink_course_id, activity_type, activity_id, assignment_id, payload) =>
  makeRequest('put', `api/integrations/edlink/sso/courses/${id}/integrations/${integration_id}/courses/${edlink_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}`, payload);

const getSsoCourseAssignment = (id, integration_id, edlink_course_id, activity_type, activity_id, assignment_id) =>
  makeRequest('get', `api/integrations/edlink/sso/courses/${id}/integrations/${integration_id}/courses/${edlink_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}`);

const createSsoCourseAssignmentSubmission = (id, integration_id, edlink_course_id, activity_type, activity_id, assignment_id, payload) =>
  makeRequest('post', `api/integrations/edlink/sso/courses/${id}/integrations/${integration_id}/courses/${edlink_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}/submissions`, payload);

const syncSsoCourseAssignmentGrades = (id, integration_id, edlink_course_id, activity_type, activity_id, assignment_id, payload) =>
  makeRequest('post', `api/integrations/edlink/sso/courses/${id}/integrations/${integration_id}/courses/${edlink_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}/submissions/sync-grades`, payload);

const disconnectSsoAssignment = (id, integration_id, edlink_course_id, activity_type, activity_id, assignment_id, payload) =>
  makeRequest('post', `api/integrations/edlink/sso/courses/${id}/integrations/${integration_id}/courses/${edlink_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}/disconnect`, payload);

const gradeEdlinkIntegrationStudentsJobStatus = (course_id, job_id) =>
  makeRequest('get', `api/integrations/edlink/sso/courses/${course_id}/job/${job_id}`);

const sendEmailToAdmin = (integration_name, admin_email, school_name) =>
  makeRequest('put', `/api/integrations/edlink/sso/send-email`, { integration_name, admin_email, school_name });

const getSsoCoursesFromLms = (integration_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/integrations/${integration_id}/courses`);

const getSsoCourseStudentsFromLms = (integration_id, edlink_course_id) =>
  makeRequest('get', `/api/integrations/edlink/sso/integrations/${integration_id}/courses/${edlink_course_id}/students`);

const createSsoCoursesFromLms = (integration_id, payload) =>
  makeRequest('post', `/api/integrations/edlink/sso/integrations/${integration_id}/courses`, payload);

const addUserToClassesSharingRule = (integration_id, payload) =>
  makeRequest('post', `/api/integrations/edlink/sso/integrations/${integration_id}/sharing-rules/add-user`, payload);

const removeUserFromClassesSharingRule = (integration_id, payload) =>
  makeRequest('post', `/api/integrations/edlink/sso/integrations/${integration_id}/sharing-rules/remove-user`, payload);

export default {
  // Subjects
  showAllSubjects,
  showSubjects,
  createNewSubject,
  editSubject,
  deleteSubject,
  getSubjectWithCategoriesPositions,

  // Grades
  showAllGrades,
  createNewGrade,
  editGradeLevel,
  deleteGradeLevel,

  // Skills
  showAllSkills,
  createNewSkill,
  editSkill,
  deleteSkill,

  // Universe Categories
  showUniverseCategory,
  showAllUniverseCategories,
  createUniverseCategory,
  editUniverseCategory,
  deleteUniverseCategory,

  // Schools
  getAllSchools,
  getSchool,
  editSchool,
  createSchool,
  deleteSchool,
  getSchoolOnlineRoundtableSummary,
  getSchoolLiveDiscussionSummary,
  getNumberStudentsEnrolled,
  getActiveTeachersAndStudents,
  getSchoolCoachesAndAdmins,
  getSitesOfSchool,

  // Districts
  getAllDistricts,
  getDistrict,
  createDistrictMembership,

  // School Users
  getUsersOfSchool,
  getFilteredUsersOfSchool,
  getUserDetailsOfSchool,
  getAdminUsersOfSchool,
  removeUsersOfSchool,
  updateSchoolUserAdminRole,
  updateUserRole,
  getSchoolUserCourses,
  getTeachersOfSchool,
  getTeacherOfCourse,
  updateCourseTeacherCoTeachers,
  stayWithTeacher,
  updateUserSchoolSite,
  updateUserSchoolRole,

  // School Courses
  addCoursesJob,
  getCoursesJobResponse,
  getSchoolCourses,
  deleteSchoolCourses,
  archiveSchoolCourses,
  getCoursesByTeacher,

  //Add users to school
  addUsersJob,
  getUsersJobResponse,

  // Users
  getUsersByEmail,
  getCoteacherByEmail,
  getUser,
  upgradeTeacher,
  adminUpdateUser,
  getTrialTeachers,
  upgradeTrialUser,
  getUsersEmailsOfSchool,
  getFilteredUsersInParlay,
  deleteUser,

  // School Invite codes
  createSchoolCode,
  editSchoolInvite,

  // School Memberships
  getSchoolMemberships,
  getSchoolMembershipTypes,
  createSchoolMembership,
  deleteSchoolMembership,

  //Admin Portal
  createSuggestion,
  editSuggestion,
  getSuggestions,
  deleteSuggestion,
  getTeachersWithLicense,

  // Activity Passes
  createActivityPasses,

  // Tags
  getTagsByTerm,
  getSkillsByTerm,

  //Analytics
  getOnlineRoundtableEngagement,
  getLiveRoundtableEngagement,
  getSchoolAnalyticsMostActiveTeachers,
  getSchoolAnalyticsInactiveTeachers,
  getSchoolAnalyticsRecentTopicsUsed,
  getSchoolAnalyticsTopUniversePortfolios,
  getActiveTeachers,
  getActiveStudents,
  getRoundtableDiscussions,
  getRoundtableDiscussionsRun,
  getUniverseTopicsUsed,
  getSchoolAnalyticsNumberOfRts,
  getSchoolAnalyticsTimeSpentOnParlay,
  getSchoolAnalyticsOnlineRts,
  getSchoolAnalyticsLiveRts,
  showSubjectsForSchool,
  getSystemWideData,
  getLatestDateUpdate,
  getTotalSchoolUsersCount,
  getTotalSchoolCoursesCount,
  getRoundtablesAnalytics,
  getDiscussionsCreated,
  getRoundtablesCreated,
  getDiscussionsRun,
  getRoundtablesRun,

  //Polls
  createPremadePoll,
  editPremadePoll,
  deletePremadePoll,
  //Integrations
  getEdlinkMetadata,
  getSsoMetadata,
  getSsoIntegrationProfile,
  setSsoIntegrationProfile,
  getSsoCourseMetadata,
  getSsoProviders,
  getSsoCourseProviders,
  getAccessToken,
  refreshAccessToken,
  getEdlinkIntegrations,
  getEdlinkIntegrationsSchool,
  generateSsoTokens,
  getUserSchoolIntegrations,
  generateSubscriptionSsoTokens,
  getSsoIntegration,
  getSsoCourses,
  getSsoCourseStudents,
  getSsoCourseTeachers,
  getCourseCategories,
  disconnectSsoIntegration,
  disconnectSsoCourseIntegration,
  disconnectStudentSsoIntegration,
  importSsoCourseStudents,
  getAvailableAssignmentsStudents,
  createSsoCourseAssignment,
  updateSsoCourseAssignment,
  getSsoCourseAssignment,
  createSsoCourseAssignmentSubmission,
  syncSsoCourseAssignmentGrades,
  disconnectSsoAssignment,
  getEdlinkProviders,
  getEdlinkSchoolProviders,
  associateEdlinkIntegrationWithSchool,
  getEdlinkSchoolIntegrationCourses,
  getEdlinkSchoolIntegrationCoursesFilters,
  rosterSchoolDataJob,
  getRosterSchoolDataJobStatus,
  getEdlinkSchoolIntegrationTeachers,
  rosterEdlinkSchoolIntegrationTeachersJob,
  getRosterEdlinkSchoolIntegrationTeachersJobStatus,
  populateEdlinkSchoolIntegrationCoursesJob,
  getPopulateEdlinkSchoolIntegrationCoursesJobStatus,
  unsyncProviderStudentFromCourse,
  sendEmailToAdmin,
  gradeEdlinkIntegrationStudentsJobStatus,
  getSsoCoursesFromLms,
  getSsoCourseStudentsFromLms,
  createSsoCoursesFromLms,
  getUserCourses,
  getUserDetails,
  addUserToClassesSharingRule,
  removeUserFromClassesSharingRule
};



// WEBPACK FOOTER //
// ./src/app/services/admin/adminServices.js